import trimLeadingSlash from 'utils/trimLeadingSlash';

const objectIdRegexp = '[0-9A-Fa-f]{24}';

export default function withCharterSegment(path: string) {
  return `/:charter(${objectIdRegexp})/${trimLeadingSlash(path)}`;
}
